import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { style: { position: 'relative', height: '57vh' } };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("i", { class: "pi pi-list" }, null, -1);
const _hoisted_4 = [
    _hoisted_3
];
import SpeedDial from 'primevue/speeddial';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AppSideSpeedDial',
    props: {
        items: {}
    },
    setup(__props) {
        const { items } = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(SpeedDial), {
                    model: _ctx.items,
                    direction: "down",
                    class: "right-0 bottom-0",
                    buttonClass: "p-button-primary",
                    tooltipOptions: { position: 'right' }
                }, {
                    button: _withCtx(({ toggleCallback }) => [
                        _createElementVNode("button", {
                            onClick: ($event) => (toggleCallback($event)),
                            class: "layout-speed-dial-button p-link layout-config-button-active",
                            type: "button"
                        }, _hoisted_4, 8, _hoisted_2)
                    ]),
                    _: 1
                }, 8, ["model"])
            ]));
        };
    }
});
